/**
 * <s-gallery-progress> — segmented progress bar for a horizontally scrolling gallery.
 *
 * Required markup:
 *   [data-product-gallery]        — the scroll container (inside this element).
 *   [data-progress-seg]           — one segment per slide; the active one gets data-active.
 *   [data-progress-label]         — optional live text updated with the current position.
 */
class SGalleryProgress extends HTMLElement {
  #ac;
  #frame = 0;

  connectedCallback() {
    this.#ac = new AbortController();
    const scroller = this.querySelector('[data-product-gallery]');
    if (!scroller) return;
    scroller.addEventListener('scroll', () => {
      cancelAnimationFrame(this.#frame);
      this.#frame = requestAnimationFrame(() => this.#update(scroller));
    }, { signal: this.#ac.signal, passive: true });
    this.#update(scroller);
  }

  disconnectedCallback() {
    this.#ac?.abort();
    cancelAnimationFrame(this.#frame);
  }

  #update(scroller) {
    const segments = this.querySelectorAll('[data-progress-seg]');
    if (!segments.length || scroller.clientWidth === 0) return;
    const offset = Math.abs(scroller.scrollLeft);
    const index = Math.min(segments.length - 1, Math.round(offset / scroller.clientWidth));
    segments.forEach((seg, i) => seg.toggleAttribute('data-active', i <= index));
    const label = this.querySelector('[data-progress-label]');
    if (label && label.dataset.template) {
      label.textContent = label.dataset.template
        .replace('__current__', String(index + 1))
        .replace('__total__', String(segments.length));
    }
  }
}

customElements.define('s-gallery-progress', SGalleryProgress);
